export default "__VITE_ASSET__3fe34376__"